
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import LogoHeader from '../Assets/Image/Xtra-Grow-Foundation-Logo.png';
import '../Assets/Css/webheader.css';
import { MdMarkEmailRead } from "react-icons/md";

import { FaHome, FaInfoCircle, FaPhoneAlt, FaTools } from "react-icons/fa";

import { useNavigate } from 'react-router-dom';


function WebHeader() {
    const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  const handleNavClick = () => {
    setExpanded(false); // Collapse navbar on link click
  };
  const location = useLocation();
  const isServicesActive = location.pathname.startsWith('/services') ||
    location.pathname === '/security' ||
    location.pathname === '/hospitality' ||
    location.pathname === '/construction' ||
    location.pathname === '/maintenance' ||
    location.pathname === '/construction' ||
    location.pathname === '/fabrication';
  const [showDropdown, setShowDropdown] = useState(false);



  const handleToggleManually = (e) => {
    e.preventDefault(); // stop default toggle behavior
    setShowDropdown(!showDropdown);
  };



  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);

  return (
    <>


      <div className="top-header">
        <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="d-flex flex-wrap align-items-center email-info">
            {/* <a
              href="https://wa.me/12145360246"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex text-white align-items-center gap-2"
              style={{ textDecoration: 'none' }}
            >
              <FaPhoneSquareAlt className="d-none d-md-flex" />
             +1 (214) 536-0246
            </a> */}
            {/* <span className="mx-2 text-white">|</span> */}
            <a
              href="mailto:david@xtragrowfoundation.org"
              className="d-flex text-white align-items-center gap-2"
              style={{ textDecoration: 'none' }}
            >
              <MdMarkEmailRead className="d-none d-md-flex" />
             david@xtragrowfoundation.org
            </a>
          </div>

          <div className="d-none d-md-flex mt-2 mt-md-0">
            <Button
              className="servicesbtn"
              size="sm"
              variant="primary"
               onClick={() => navigate("/donationpayment")}
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                borderRadius: '5px',
                backgroundColor: 'white',
                border: '1px solid #FBE108',
                color:'#036839',
                fontWeight:'bold'
                
              }}
            >
            Donate Now
            </Button>
          </div>
        </Container>
      </div>


      {/* Main Navbar */}
      <Navbar expand="lg" className="custom-navbar">
        <Container className="d-flex justify-content-between align-items-center">
          {/* Logo only visible on mobile (hidden on desktop) */}
          <Navbar.Brand href='/' >
            <img src={LogoHeader} alt="Logo" className="navbar-logo" />
          </Navbar.Brand>

          {/* Toggle button only visible on mobile */}
          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} className="d-lg-none" />

          {/* Main Nav visible only on desktop */}
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center d-none d-lg-flex">
            <Nav>
              <Nav.Link as={NavLink} to="/" onClick={handleClose}>Home</Nav.Link>
              <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>About Us</Nav.Link>

               <Nav.Link as={NavLink} to="/partners" onClick={handleClose}>Partners</Nav.Link>
                

              <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Offcanvas Sidebar for mobile */}
      <Offcanvas show={showSidebar}
        onHide={handleClose} placement="start"
        className="custom-offcanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <a href="/">
              <img src={LogoHeader} alt="Logo" className="navbar-logo" />
            </a>
          </Offcanvas.Title>

        </Offcanvas.Header>
        <Offcanvas.Body className='offcanvasbody'>
          <Nav className="flex-column">
            <Nav.Link as={NavLink} to="/" onClick={handleClose}>
              <FaHome size={18} className="me-2" /> Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>
              <FaInfoCircle size={18} className="me-2" /> About Us
            </Nav.Link>
            <Nav.Link as={NavLink} to="/partners" onClick={handleClose}>
              <FaInfoCircle size={18} className="me-2" /> Partners
            </Nav.Link>
            

            <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
              <FaPhoneAlt size={18} className="me-2" /> Contact Us
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

    </>
  );
}

export default WebHeader;
